import React from "react";

/* Semicircular SVG gauge. value may be null -> renders empty arc + "--". */
export function Gauge({ value, max = 100, label, unit = "", colorFor, size = 180, testid }) {
  const R = 70;
  const ARC = Math.PI * R; // semicircle path length ≈ 219.9
  const has = value !== null && value !== undefined && !Number.isNaN(value);
  const pct = has ? Math.min(Math.max(value / max, 0), 1) : 0;
  const offset = ARC * (1 - pct);
  const color = (colorFor ? colorFor(has ? value : 0) : "var(--accent)");

  return (
    <div className="flex flex-col items-center" data-testid={testid}>
      <svg viewBox="0 0 180 110" width={size} height={size * 0.61} className="overflow-visible">
        <path d="M20 95 A70 70 0 0 1 160 95" fill="none" stroke="var(--track)" strokeWidth="11" strokeLinecap="round" />
        <path
          d="M20 95 A70 70 0 0 1 160 95"
          fill="none"
          stroke={color}
          strokeWidth="11"
          strokeLinecap="round"
          strokeDasharray={ARC}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.6s ease, stroke 0.3s ease" }}
        />
        <text x="90" y="80" textAnchor="middle" fontFamily="JetBrains Mono" fontSize="26" fontWeight="600" fill={color}>
          {has ? (Number.isInteger(value) ? value : value.toFixed(1)) : "--"}
        </text>
        <text x="90" y="98" textAnchor="middle" fontFamily="JetBrains Mono" fontSize="11" fill="var(--t2)">
          {unit}
        </text>
      </svg>
      <span className="uppercase tracking-[0.18em] text-[10px] font-bold text-[var(--t2)] mt-1">{label}</span>
    </div>
  );
}
